'use strict';

const { getLevelConfig: getBuiltInLevelConfig } = require('../config/levels');
const { getBossLevelConfig: getBuiltInBossConfig } = require('../config/boss-levels');

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

const DEFAULT_ENGAGEMENT = Object.freeze({
  scoring: { survivalPointsPerSecond: 10, clearBonusPerLevel: 1000, streakBonusPerClear: 500, maxStreakBonus: 5000 },
  progression: { baseRunXp: 10, scoreXpDivisor: 1000, maxScoreXp: 50, clearXp: 40, levelBaseXp: 100, levelIncrementXp: 25 },
  controls: { touchSensitivity: { low: 0.75, medium: 1, high: 1.25 } },
  dailyChallenges: [], achievements: [], cosmetics: []
});

class GameConfigService {
  constructor(storage, cloud) {
    this.storage = storage;
    this.cloud = cloud;
    this.published = storage.loadGameConfig();
  }

  setPublished(payload) {
    if (!payload || !payload.config) return;
    this.published = clone(payload);
    this.storage.saveGameConfig(this.published);
  }

  async refresh() {
    const payload = await this.cloud.getCurrentConfig();
    this.setPublished(payload);
    return payload;
  }

  getLevelConfig(level) {
    const base = { ...getBuiltInLevelConfig(level) };
    const config = this.published && this.published.config;
    const globalOverrides = (config && config.globalOverrides) || {};
    const levelOverrides = ((config && config.levelOverrides) || {})[String(base.level)] || {};
    const overrides = { ...globalOverrides, ...levelOverrides };
    Object.keys(overrides).forEach((key) => {
      base[key === 'durationSeconds' ? 'duration' : key] = clone(overrides[key]);
    });
    const boss = { ...getBuiltInBossConfig(base.level) };
    const bossOverrides = {
      ...((config && config.bossGlobalOverrides) || {}),
      ...(((config && config.bossLevelOverrides) || {})[String(base.level)] || {})
    };
    Object.keys(bossOverrides).forEach((key) => { boss[key] = clone(bossOverrides[key]); });
    boss.patterns = Object.freeze([...(boss.patterns || [])]);
    boss.variant = Object.freeze({ ...boss.variant });
    base.boss = Object.freeze(boss);
    return Object.freeze(base);
  }

  getEngagementConfig() {
    const source = this.published && this.published.config && this.published.config.engagement;
    if (!source) return clone(DEFAULT_ENGAGEMENT);
    return {
      ...clone(DEFAULT_ENGAGEMENT),
      ...clone(source),
      scoring: { ...clone(DEFAULT_ENGAGEMENT.scoring), ...(source.scoring || {}) },
      progression: { ...clone(DEFAULT_ENGAGEMENT.progression), ...(source.progression || {}) },
      controls: {
        touchSensitivity: {
          ...clone(DEFAULT_ENGAGEMENT.controls.touchSensitivity),
          ...((source.controls && source.controls.touchSensitivity) || {})
        }
      }
    };
  }

  getTouchSensitivity(key) {
    const values = this.getEngagementConfig().controls.touchSensitivity;
    return Number(values[key]) || Number(values.medium) || 1;
  }
}

module.exports = GameConfigService;
